"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageConfig = createPageConfig;
function createPageConfig(pageConfig) {
    return pageConfig;
}
//# sourceMappingURL=createPageConfig.js.map